// extracted by mini-css-extract-plugin
export var fullHeightState = "_3w-7";
export var headerCell = "_3w-1";
export var loadingStateCell = "_3w-4";
export var rowWrapper = "_3w-3";
export var standaloneTable = "_3w-8";
export var standaloneTableWithBodyFill = "_3w-9";
export var stateCell = "_3w-5";
export var table = "_3w-0";
export var tableBodyFiller = "_3w-6";
export var white = "_3w-2";